function Qoraal_Qiime(){
    return(
        <div className="q ciwaano_se">
        <h2><span><i className="fa-solid fa-coins"></i> Qiimayasha</span> Noocyada Dahabka</h2>
        <p className="ciwaan_wayn_qi">Dhaqdhaqaaqa Qiimaha Dahabka </p>
        <div className="qurxinta">
            <span>
                
            </span>
        </div>
        <p className="qoraal">
        Shabakada E-Sako.Web.App, Waa #1 Shabakadii Ugu Horaysay Guud Ahaan Gayiga Soomalida, Ee Kuu Xisaabinaysa Noocyada Kala Duwan ee Sakadda (Geel, Adhi, Lo' iyo Dahab), Taas Oo Loo Raacayo Si Waafaqsan Mad-habka Shaaficiga, Waxayna Si Toosa Ula Shaqayanaysaa Oo Ay Ku Xidhantahay Shabakada Caalamiga Ee Qaabilsan Qiimaha Dahabka, Iyada oo La Isticmaalayo IPA-ga Shabakadaas, Waxa aad Ka Eegi Kartaa Shabakada E-Sako, Maalin Walba Halka Uu Marayo Qiimaha Noocyada Kala Duwan Ee Dahabka Sida:- 24, 22, 21 , 20, 18 Qiimayaashan Oo Isbadalkoodu Uu oo Isbadalayo Daqiiqad Walba. Taasna Ay Keenayso In Xisaabta Noocyada Dahabka Iyo Dollarka, Markaad Doonayso Inaad Bixiso Sakadooda Aad U Baahantahay Meel Aad Kala Socoto Maalinta, Saacadaa Iyo Daqiiqada Aad Sakada Bixinayso.
        </p>
    </div>
    )
}


export default Qoraal_Qiime